const INTERVIEW_QUESTION_PHASE = {
  intro: "INTRO",
  waiting: "WAITING",
  countdown: "COUNTDOWN",
  recording: "RECORDING",
};

const INTERVIEW_PHASE = {
  intro: "INTRO",
  finished: "FINISHED",
  resume: "RESUME",
  permission: "PERMISSION",
  setup: "SETUP",
  question: "QUESTION",
};

const INTERVIEW_MEDIA_DEVICES = {
  camera: "camera",
  microphone: "microphone",
};

const INTERVIEW_MEDIA_DEVICES_STATUS = {
  granted: "granted",
};

const INTERVIEW_QUESTION_TIME_LIMIT_OPTIONS = [
  { value: 60, label: "1 minute" },
  { value: 120, label: "2 minutes" },
  { value: 180, label: "3 minutes" },
  { value: 240, label: "4 minutes" },
  { value: 300, label: "5 minutes" },
];

const QUESTION_PRE_TIMER_SECONDS = 15;
const QUESTION_COUNTDOWN_SECONDS = 3;
const RECORDING_TIME_SECONDS = 120;
const MIN_RECORDING_SIZE_BYTES = 10000;

export {
  QUESTION_PRE_TIMER_SECONDS,
  QUESTION_COUNTDOWN_SECONDS,
  RECORDING_TIME_SECONDS,
  INTERVIEW_PHASE,
  INTERVIEW_MEDIA_DEVICES,
  INTERVIEW_MEDIA_DEVICES_STATUS,
  INTERVIEW_QUESTION_TIME_LIMIT_OPTIONS,
  MIN_RECORDING_SIZE_BYTES,
};

export default INTERVIEW_QUESTION_PHASE;
